import React, { useContext, useEffect } from 'react';
import { func, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { PageContext } from '@axiom/ui';

import OpportunityDetails from '../components/OpportunityDetails/OpportunityDetails';
import DetailLayout from '../layouts/detail';
import { getDecoratedOpportunity } from '../redux/actions/opportunities';
import { makeOpportunitiesViewSelector } from '../redux/selectors/opportunities-profile-component-selector';
import { UserSettingsUtil } from '../utils/user-settings-util';

export const OpportunityDetailPageComponent = ({
  getDecoratedOpportunity: getDecoratedOpportunityAction,
  user,
}) => {
  const { id } = useParams();
  const { setTitle } = useContext(PageContext);
  setTitle('Opportunity Details');

  useEffect(() => {
    getDecoratedOpportunityAction(id);
  }, [id]);

  return (
    <DetailLayout
      user={user}
      wide
      showGreyBackground={UserSettingsUtil.shouldShowNewOpportunityTalentView(
        user.settings
      )}
    >
      <OpportunityDetails expanded isDetail onCloseSidedrawer={() => {}} />
    </DetailLayout>
  );
};

OpportunityDetailPageComponent.defaultProps = {
  user: null,
};

OpportunityDetailPageComponent.propTypes = {
  getDecoratedOpportunity: func.isRequired,
  user: shape({
    activeDirectorySecurityGroup: string,
  }),
};

const mapDispatchToProps = {
  getDecoratedOpportunity,
};

export const OpportunityDetailPage = connect(
  makeOpportunitiesViewSelector,
  mapDispatchToProps
)(OpportunityDetailPageComponent);
